import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI';
import GenericAboutIcon from '../assets/abouticon_default.png';
import styles from './SiteIcon.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { QuirkImage } from './QuirkImage.js';
interface SiteIconType {
	size?: number;
	rounded?: boolean;
}

export const SiteIcon: React.FC<SiteIconType> = ({ size, rounded }) => {
	const [lightIcon, setLightIcon] = useState<string>();
	const [darkIcon, setDarkIcon] = useState<string>();

	const { data: siteSettings, isSuccess } = useGetPublicInformationQuery();
	const lightModeIcon = siteSettings?.lightIcon;
	const darkModeIcon = siteSettings?.darkIcon;

	const IconStyle = { width: size || 30, height: size || 30, borderRadius: rounded ? '100%' : 'inherit' };

	useEffect(() => {
		if (isSuccess) {
			if (lightModeIcon !== '') {
				setLightIcon(`api/siteSettings/image/${lightModeIcon}`);
			} else {
				setLightIcon(GenericAboutIcon);
			}
		}
	}, [isSuccess, lightModeIcon]);

	useEffect(() => {
		if (isSuccess) {
			if (darkModeIcon !== '') {
				setDarkIcon(`api/siteSettings/image/${darkModeIcon}`);
			} else {
				setDarkIcon(GenericAboutIcon);
			}
		}
	}, [darkModeIcon, isSuccess]);

	return (
		<>
			{lightIcon && (
				<QuirkImage
					className={classNames(styles.image, sharedStyles.lightmode)}
					style={IconStyle}
					src={lightIcon}
					fallback={GenericAboutIcon}
					alt={'Icon'}
				/>
			)}
			{darkIcon && (
				<QuirkImage
					className={classNames(styles.image, sharedStyles.darkmode)}
					style={IconStyle}
					src={darkIcon}
					fallback={GenericAboutIcon}
					alt={'Icon'}
				/>
			)}
		</>
	);
};
